import { locale as importantDialog } from '@core-utils/important-dialog/components/important-dialog/i18n/en';

const localesData = {
    ...importantDialog.data
};

export const locale = {
    lang: 'en',
    data: localesData
};